import {authMiddleware} from "./loginAction";
import cfg, {
  handleResponse,
  UPDATE_CHAT_ERROR,
  UPDATE_CHAT_TOTALS,
  UPDATE_CHAT_LIST,
  UPDATE_CHAT_LOADING,
  UPDATE_CHAT_MESSAGES,
  UPDATE_CHAT_ITEM_FAVORITE,
  formatStatusError,
  UPDATE_CHAT_REMOVE_MESSAGE,
  UPDATE_CHAT_READ_MESSAGE, UPDATE_CHAT_REMINDER_EDIT, UPDATE_CHAT_UNANSWERED, UPDATE_CHAT_MESSAGES_LOADING,
  UPDATE_CHAT_CLIENT_ID
} from "../constants";

// chatListAction - get chat list for current curator
export const chatListAction = (filter, signal) => (dispatch, getState) => {
  dispatch({type: UPDATE_CHAT_LOADING, loading: true});
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/clients-list', {
    method: "POST",
    body: JSON.stringify(prepareChatListFilter(filter)),
    headers,
    signal
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_LIST, list: data.items || [], total: data.total, reminders: data.reminders || []});
      dispatch({type: UPDATE_CHAT_TOTALS, totals: data.count || {}});
      localStorage.setItem('dc_currentChatFilter', JSON.stringify(filter));
      return true;
    } else {
      dispatch({type: UPDATE_CHAT_ERROR, errors: data.errors && data.errors.length ? data.errors : ['error_other']});
      return false;
    }
  }).catch(() => {
    return false;
  });
};

// chatTotalsAction - get chat totals values
export const chatTotalsAction = (filter, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/clients-list-count', {
    method: "POST",
    body: JSON.stringify(prepareChatListFilter(filter)),
    headers,
    signal
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_TOTALS, totals: data.count || {}});
      return true;
    } else {
      return false;
    }
  }).catch(() => {
    return false;
  });
};

// chatMessagesAction - get chat messages
export const chatMessagesAction = (filter) => (dispatch, getState) => {
  dispatch({type: UPDATE_CHAT_MESSAGES_LOADING, loading: true});
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/messages', {
    method: "POST",
    body: JSON.stringify({...filter, sort: 'created', sortd: 'desc'}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_MESSAGES, messages: data.items || [], total: data.total, offset: filter.offset});
    } else {
      dispatch({type: UPDATE_CHAT_MESSAGES_LOADING, loading: false});
    }
  }).catch((e) => {
    console.log('messages', e);
    dispatch({type: UPDATE_CHAT_CLIENT_ID});
    dispatch({type: UPDATE_CHAT_MESSAGES_LOADING, loading: false});
  });
};

// chatReminderAction - set chat reminder for current curator
export const chatReminderAction = (body) => (dispatch, getState) => {
  dispatch({type: UPDATE_CHAT_LOADING, loading: true});
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/messages-update-remind', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_REMINDER_EDIT, item: body});
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

export const chatMessageAddAction = (clients_id, chat_id, message_type, message_text, file, message_id, reply_to_message_id, decline = false, ai_origin = null) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  return new Promise((resolve, reject) => {
    const formData = new FormData();

    if (file && file.name) {
      formData.append("file", file, file.name);
    }
    if (message_id) {
      formData.append("message_id", message_id);
    }
    if (reply_to_message_id) {
      formData.append("reply_to_message_id", reply_to_message_id);
    }
    if (decline) {
      formData.append("decline", decline);
    }
    if (ai_origin) {
      formData.append("ai_origin", ai_origin);
    }
    formData.append("clients_id", clients_id);
    formData.append("chat_id", chat_id);
    formData.append("message_type", message_type);
    formData.append("message_text", message_text);

    const req = new XMLHttpRequest();
    req.addEventListener("load", event => {
      if (req.status === 200) {
        try {
          let data = JSON.parse(req.response);
          if (data.status === 'ok') {
            resolve(data);
          } else if (data.errors && data.errors.length > 0) {
            reject(new Error(data.errors[0]));
          } else {
            reject(new Error('error_other'));
          }
        } catch (e) {
          reject(new Error('error_other'));
        }
      } else {
        reject(formatStatusError(req.status));
      }
    });

    req.upload.addEventListener("error", event => {
      reject(req.response);
    });

    // A connection drop after the body has been uploaded fires error on the request itself,
    // not on upload. Without these listeners the promise never settles: the input panel stays
    // disabled and the optimistically dismissed AI suggestion is never restored.
    req.addEventListener("error", () => {
      reject(new Error('error_other'));
    });
    req.addEventListener("abort", () => {
      reject(new Error('error_other'));
    });
    req.addEventListener("timeout", () => {
      reject(new Error('error_other'));
    });
    // A deadline is needed so a silently stalled connection cannot hang the promise forever,
    // which would leave the input panel disabled and an optimistically dismissed AI suggestion
    // unrecoverable. Uploads get a far longer one: a photo from a phone is easily 5-15 MB and a
    // curator on a weak mobile link legitimately needs minutes for it.
    req.timeout = file ? 600000 : 120000;

    req.open("POST", cfg.base_url + '/auth/message');
    req.setRequestHeader("Authorization", 'Bearer ' + token);
    req.send(formData);
  });
};

export const chatMessageRemoveAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/message/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_REMOVE_MESSAGE, message_id: id});
      return true;
    }

    if (data.errors && data.errors.length > 0) {
      alert(data.errors[0]);
    }

  }).catch((e) => {
    console.log('message delete error', e);
  });
};

export const chatMessageReadAction = (chat_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/messages-update-read-status', {
    method: "POST",
    body: JSON.stringify({chat_id}),
    headers
  }).then(handleResponse).then(() => {
    dispatch({type: UPDATE_CHAT_READ_MESSAGE, chat_id});
  }).catch((e) => {
    console.log('message read error', e);
  });
};

export const chatAddFavoriteAction = (clients_id, chat_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/favorites', {
    method: "POST",
    body: JSON.stringify({clients_id, chat_id}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_ITEM_FAVORITE, id: clients_id, is_favorites: true});
    }
  }).catch((e) => {
    console.log('favorites add error', e);
  });
};

export const chatRemoveFavoriteAction = (clients_id, chat_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/favorites', {
    method: "DELETE",
    body: JSON.stringify({clients_id, chat_id}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_ITEM_FAVORITE, id: clients_id, is_favorites: false});
    }
  }).catch((e) => {
    console.log('favorites remove error', e);
  });
};

export function prepareChatListFilter(data) {
  const filter = {...data};
  if (!filter.length_msg) {
    filter.length_from = 0;
    filter.length_to = 0;
  } else {
    filter.length_from *= 1;
    filter.length_to *= 1;
  }
  filter.period_from = filter.period_from ? filter.period_from + ' 00:00:00' : '';
  filter.period_to = filter.period_to ? filter.period_to + ' 23:59:59' : '';

  return filter;
};

export const chatAnsweredAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/messages-answered', {
    method: "POST",
    body: JSON.stringify({id}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_UNANSWERED, id: id});
      return true;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};
